import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import ListItem from 'components/Luxkit/List/ListItem'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import FormatCurrency from 'components/Common/FormatCurrency'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import { generateDurations } from 'selectors/bedbankOfferSelectors'
import LineFireIcon from 'components/Luxkit/Icons/line/LineFireIcon'

const SizedDropdownContainer = styled(DropdownContainer)`
  max-height: 60vh;
`

const LimitedTimeSpecial = styled(BodyText)`
  display: flex;

  & > div {
    padding-right: ${rem(5)};
  }
`

interface Props {
  checkIn?: moment.Moment;
  checkOut?: moment.Moment;
  duration: number;
  durationOptions: App.BedbankDurationOption[];
  onClose?: () => void;
}

function CalendarDurationDropdown(props: Props) {
  const { onClose, duration, checkIn, checkOut, durationOptions } = props
  const dispatch = useOfferPageDispatch()

  const onDurationClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    const duration = parseInt(e.currentTarget.dataset.duration, 10)

    if (checkIn && checkOut) {
      const checkOut = checkIn?.clone().add(duration, 'days')
      dispatch({ type: OfferPageActions.setCheckOutDate, checkOut })
    }

    dispatch({ type: OfferPageActions.setDuration, duration })
    onClose?.()
  }, [dispatch, onClose, checkIn, checkOut])

  return (
    <SizedDropdownContainer title="How long do you want to stay?" onClose={onClose}>
      {durationOptions.map(option => <ListItem
        key={option.duration}
        title={pluralizeToString('night', option.duration)}
        selected={option.duration === duration}
        data-duration={option.duration}
        onClick={onDurationClick}
        subtitle={option.hasPromo && <LimitedTimeSpecial variant="medium" colour="highlight">
          <div><LineFireIcon size="S" colour="secondary-normal" /></div>Limited Time Special
        </LimitedTimeSpecial>}
      >
        {option.hasPromo && option.price && <BodyText variant="medium" colour="neutral-two">
          From{' '}
          <BodyText as="span" variant="medium" colour="neutral-one" weight="bold">
            <FormatCurrency value={option.price} />
          </BodyText>
        </BodyText>}
      </ListItem>)}
    </SizedDropdownContainer>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  checkIn: state.checkInDate,
  checkOut: state.checkOutDate,
  duration: state.duration,
  durationOptions: generateDurations(state, appState),
}))(CalendarDurationDropdown)
